module.exports = __webpack_public_path__ + "static/img/MarcoZappatore_signature_transparent.43a2f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MarcoZappatore_signature_transparent.png
// module id = UD6d
// module chunks = 1